import React from 'react';
import { useToggle } from 'usehooks-ts';
import { useParams } from 'react-router-dom';

import { Downloadble } from '../../downloadable';
import { DownloadReportFeedbackAsync } from '../../../../services/event-reports';

export const DownloadableResponses: React.FC<{
  amount: number;
  fileName: string;
}> = ({ amount, fileName }) => {
  const { eventId, detailId } = useParams();

  const [isLoading, toggleIsLoading] = useToggle(false);

  const onClick = async () => {
    if (!eventId) return;

    toggleIsLoading();
    try {
      await DownloadReportFeedbackAsync(parseInt(eventId!), fileName, [
        detailId
      ]);
    } catch (err) {
      console.error(err);
    } finally {
      toggleIsLoading();
    }
  };

  return (
    <Downloadble
      text={'Responses'}
      icon={'checklist'}
      amount={amount}
      bgColor={'#1D252D'}
      onClick={onClick}
      disabled={isLoading}
      downloadText={isLoading ? 'Downloading' : 'Download XLSX'}
    />
  );
};
